<template>
	<div class="flex flex-col shadow-sm mb-6 rounded-md bb-component-background overflow-hidden">
		<div class="flex-auto p-3">
			<h2
				v-if="data.heading || data.template_heading"
				class="uppercase mb-1 bb-component-heading"
			>
				{{ data.heading || data.template_heading }}
			</h2>
			<div class="bb-component-content">
				<div :key="article.id" v-for="article in data.articles" class="mb-2">
					<div tag="div">
						<div class="font-bold">{{ article.question }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
    name: "FAQ",
    props: ["data"]
};
</script>
